<template>
  <div class="container">

    <el-container>

      <el-aside width="240px">
        <div class="left-nvi">
          <el-tree
            :data="treeData"
            :props="defaultProps"
            :default-expand-all="true"
            :highlight-current="true"
            :expand-on-click-node="false"
            @node-click="handleNodeClick"
            style="color: #034172"
          >
          </el-tree>
        </div>
      </el-aside>

      <el-main>
        <el-card>
          <div>
            <div style="margin-bottom: 30px">
              <el-row>
                <el-col :span="6">
                  <div class="name-div">王瑞</div>
                </el-col>
                <el-col :span="18">
                  <div class="job-div">应聘职位：Flutter开发工程师</div>
                </el-col>
              </el-row>
            </div>

            <div>
              <div class="area" id="resume1">基本信息</div>

              <div>

                <div class="info">
                  <el-row>
                    <el-col :span="4">电话：</el-col>
                    <el-col :span="8">186-2402-3153</el-col>
                    <el-col :span="4">性别：</el-col>
                    <el-col :span="8">男</el-col>
                  </el-row>
                </div>

                <div class="info">
                  <el-row>
                    <el-col :span="4">邮箱：</el-col>
                    <el-col :span="8">work@doyle.wang</el-col>
                    <el-col :span="4">年龄：</el-col>
                    <el-col :span="8">30</el-col>
                  </el-row>
                </div>

                <div class="info">
                  <el-row>
                    <el-col :span="4">学历：</el-col>
                    <el-col :span="8">本科</el-col>
                    <el-col :span="4">专业：</el-col>
                    <el-col :span="8">软件工程</el-col>
                  </el-row>
                </div>

                <div class="info">
                  <el-row>
                    <el-col :span="4">工作年限：</el-col>
                    <el-col :span="8">7年</el-col>
                    <el-col :span="4">个人主页：</el-col>
                    <el-col :span="8">www.doyle.wang</el-col>
                  </el-row>
                </div>

              </div>

            </div>

            <div>
              <div class="area" id="resume2">专业技能</div>
              <div class="info info-ol">
                <ol>
                  <li>熟练使用 Dart 、Objective-C 进行开发</li>
                  <li>具有一定的软件调试和性能优化经验</li>
                  <li>熟练使用 Flutter 进行 iOS / Android 项目开发，已有近两年经验</li>
                  <li>精通使用 Flutter 中 dio，chewie，fluwx，flutter_swiper，flutter_cached_network_image 等常用三方框架</li>
                  <li>熟练使用 Flutter 中 bloc，eventBus，getx</li>
                  <li>熟练使用 MethodChannel 实现 Flutter 与原生通信</li>
                  <li>熟练使用 Flutter 开发微信登录，支付宝支付，影音播放</li>
                  <li>熟练使用 Vue 、Golang 进行开发</li>
                  <li>熟练使用 OC 中的 AFN、SDWebImage、MJRefresh、Masonary 等常用三方框架</li>
                  <li>精通掌握 JSON/XML 解析等</li>
                  <li>熟练掌握 shared_preferences ，sqflite 实现本地缓存与清除</li>
                  <li>精通使用 MVC，MVVM 等设计模式</li>
                  <li>精通操作 App 上架及版本更新</li>
                  <li>熟练使用 Git 、SVN 代码版本管理工具</li>
                  <li>熟练使用 CocoaPods 下载管理第三方类库</li>
                </ol>
              </div>
            </div>

            <div>
              <div class="area" id="resume3">工作经历</div>
              <div class="info">
                <el-row>
                  <el-col :span="8">2020/12 – 至今</el-col>
                  <el-col :span="16">北京中铁科客货运输技术有限公司</el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">2019/10 – 2020/08</el-col>
                  <el-col :span="16">星系场科技有限公司</el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">2018/09 – 2019/09</el-col>
                  <el-col :span="16">沈阳小罗潮人网络科技有限公司</el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">2015/07 – 2018/09</el-col>
                  <el-col :span="16">沈阳迅云网络科技有限公司</el-col>
                </el-row>
              </div>
            </div>

            <div>
              <div class="area" id="resume4">项目经验</div>
              <div>
                <el-collapse v-model="activeNames">

                  <el-collapse-item name="1">
                    <template slot="title">
                      <div class="project-title" id="resume4-1">开发项目（1）—— Starry</div>
                    </template>
                    <div>
                      <div class="title">项目简介：</div>
                      <div class="info info-ul">
                        <ul>
                          <li>Starry是一款摄影垂直社区及预约平台的手机App，是摄影行业垂直领域的作品展示、摄影服务预约交易平台。摄影师可以在Starry发布摄影服务以及作品，用户通过智能匹配及基于关键词、地理位置、价格区间范围等条件搜索并预约摄影服务。</li>
                        </ul>
                      </div>
                      <div class="title">项目职责：</div>
                      <div class="info info-ul">
                        <ul>
                          <li>搭建项目框架，完成 App 从 0 到 1 的搭建和设计直到App上线；</li>
                          <li>负责完成用户版摄影服务展示、预约、支付以及个人中心等功能；</li>
                          <li>负责完成商家版摄影服务以及作品的上传、修改、删除、复制等功能；</li>
                          <li>负责完成管理员后台管理功能；</li>
                          <li>负责完成摄影服务相关的活动功能；</li>
                          <li>参与完成即时通信、分享；</li>
                          <li>参与完成上传图片多任务处理。</li>
                        </ul>
                      </div>
                      <div class="title">项目经验：</div>
                      <div class="info info-ul">
                        <ul>
                          <li>与后台共同设计摄影服务上传逻辑，提高 80% 上传成功率；</li>
                          <li>共同设计图片 Model 类，优化图片上传及显示，减少内存消耗，降低 60% crash 率；</li>
                          <li>更换图片压缩三方库，提升 30% 压缩速度；</li>
                          <li>封装按钮、输入框、文本、图片、导航栏等组件。</li>
                        </ul>
                      </div>
                      <div class="title">技术难点：</div>
                      <div class="info info-ul">
                        <ul>
                          <li>根据UI设计封装自定义组件（Button、Label、TextField、AppBar、Image）；</li>
                          <li>使用 fluwx 实现微信登录、分享，使用 flutter_alipay 实现支付宝绑定以及支付；</li>
                          <li>使用 event_bus 实现用户权限切换、用户相关操作后的刷新；</li>
                          <li>使用 flutter_bloc 实现页面状态的监听（例如页面加载）；</li>
                          <li>封装 dio 实现 App 网络请求；</li>
                          <li>封装 flutter_image_compress 实现上传图片的压缩，减少相应内存占用；</li>
                          <li>封装 shared_preferences 实现个人资料、摄影服务草稿箱等本地存储；</li>
                          <li>封装 pull_to_refresh 实现上拉加载、下拉刷新；</li>
                          <li>使用 MethodChannel 实现原生腾讯地图对接；</li>
                          <li>封装 webview 实现用户协议的显示。</li>
                        </ul>
                      </div>
                    </div>
                  </el-collapse-item>

                  <el-collapse-item name="2">
                    <template slot="title">
                      <div class="project-title" id="resume4-2">开发项目（2）—— 选剧</div>
                    </template>
                    <div>
                      <div class="title">项目简介：</div>
                      <div class="info info-ul">
                        <ul>
                          <li>选剧是悬疑类互动视频，玩家根据不同选项经历不同结局，从而完成相关任务获取成就，根据不同成就组合获得积分，与其他玩家比拼。</li>
                        </ul>
                      </div>
                      <div class="title">项目职责：</div>
                      <div class="info info-ul">
                        <ul>
                          <li>项目负责人，搭建项目框架，完成 App 从 0 到 1 的搭建和设计直到App上线；</li>
                          <li>对接后台，完成剧本点赞以及排行榜功能；</li>
                          <li>与相关人员配合，完成多个剧本的剧情、成就、任务等配置信息；</li>
                          <li>制作剧本配置工具，方便相关人员维护；</li>
                          <li>使用 cocos 完成微信小游戏开发，使用 Flutter 完成 iOS 和 Android 开发。</li>
                        </ul>
                      </div>
                      <div class="title">项目经验：</div>
                      <div class="info info-ul">
                        <ul>
                          <li>前期使用 cocos 开发，后使用 Flutter，提高 100% 视频播放成功率；</li>
                          <li>优化代码，提升剧本流畅度。</li>
                        </ul>
                      </div>
                      <div class="title">技术难点：</div>
                      <div class="info info-ul">
                        <ul>
                          <li>封装 dio 实现网络请求，从阿里云OSS获取剧本信息；</li>
                          <li>使用 shared_preferences 实现本地成就和视频存档，减少网络请求次数；</li>
                          <li>使用 chewie 实现网络视频播放，加入暂停、跳过以及看过剧情选集功能；</li>
                          <li>设计存档 Model 类，实现相关剧情完成度、播放次数等信息存取；</li>
                          <li>使用 flutter_screenUtil 实现不同手机型号的适配；</li>
                          <li>封装 Animation 类实现相关组件动画；</li>
                          <li>封装 Image，减少内存占用，优化性能，实现网络图片显示；</li>
                          <li>使用 jpush_flutter 实现最新剧本推送功能；</li>
                          <li>封装自定义环形进度条；</li>
                          <li>优化视频播放器，解决部分视频不能播放的 bug。</li>
                        </ul>
                      </div>
                    </div>
                  </el-collapse-item>

                  <el-collapse-item name="3">
                    <template slot="title">
                      <div class="project-title" id="resume4-3">开发项目（3）—— 不眨眼</div>
                    </template>
                    <div>
                      <div class="title">项目简介：</div>
                      <div class="info info-ul">
                        <ul>
                          <li>不眨眼是线上真人角色扮演剧本杀 app，视频版狼人杀。视频版剧本代入感更强，多人语音通话，引发玩家游戏兴趣，精美搜证场景，拥有众多精品剧本。</li>
                        </ul>
                      </div>
                      <div class="title">项目职责：</div>
                      <div class="info info-ul">
                        <ul>
                          <li>参与搭建项目框架，完成 App 从 0 到 1 的搭建和设计直到App上线；</li>
                          <li>负责游戏内流程设计，封装多个不同流程，方便后期的剧本迭代；</li>
                          <li>负责游戏内页面铺设，以及相关动画效果；</li>
                          <li>负责游戏内各个阶段通信，使游戏进入下一环节；</li>
                          <li>使用 Airbnb 封装动画类，便于使用。</li>
                        </ul>
                      </div>
                      <div class="title">技术难点：</div>
                      <div class="info info-ul">
                        <ul>
                          <li>封装 AFNetWorking 实现网络请求；</li>
                          <li>使用腾讯 GME 和声网 SDK 完成实时语音；</li>
                          <li>使用 websocket 实现游戏内环节切换；</li>
                          <li>使用 avplayer 实现视频剧本时间节点跳转以及快进；</li>
                          <li>封装自定义 alertview、button、label 完成特效动画；</li>
                          <li>使用 Block、代理、消息通知来做页面之间的传递；</li>
                          <li>使用友盟 SDK 实现玩家的相关数据统计；</li>
                          <li>封装剧本、关卡、线索等Model类，便于后续迭代；</li>
                          <li>封装场景控件，可根据后台数据切换；</li>
                          <li>优化代码，降低内存使用，减少 crash。</li>
                        </ul>
                      </div>
                    </div>
                  </el-collapse-item>

                  <el-collapse-item name="4">
                    <template slot="title">
                      <div class="project-title" id="resume4-4">开发项目（4）—— 待购</div>
                    </template>
                    <div>
                      <div class="title">项目简介：</div>
                      <div class="info info-ul">
                        <ul>
                          <li>待购是全新的 C2C 购物平台，买家提出购买需求，商家报价并接单，减少买家搜索商品时间，根据商家报价选择实惠的商品。全新的购物模式，让购物更潮流，让生活更有魅力。</li>
                        </ul>
                      </div>
                      <div class="title">项目职责：</div>
                      <div class="info info-ul">
                        <ul>
                          <li>iOS端项目负责人，项目采用 MVC 设计模式，完成 App 从 0 到 1 的搭建和设计直到 App 上线；</li>
                          <li>与项目相关人员配合共同完成开发设计工作；</li>
                          <li>优化代码，规范代码质量，提高开发效率，保证系统的稳定性；</li>
                          <li>封装多个控件，可简单集成并维护；</li>
                          <li>维护项目，适配新版本系统，提升性能。</li>
                        </ul>
                      </div>
                      <div class="title">技术难点：</div>
                      <div class="info info-ul">
                        <ul>
                          <li>封装 AFNetWorking 实现网络请求；</li>
                          <li>封装自定义图片请求，应对域名变动造成图片请求失败；</li>
                          <li>使用 Socket 实现即时通信；</li>
                          <li>使用 FMDB 设计本地购物车和即时通信数据库；</li>
                          <li>使用 SDWebImage 实现网络图片加载；</li>
                          <li>使用 AVAudioRecorder 实现语音发布商品；</li>
                          <li>使用 CABasicAnimation 实现相关动画效果；</li>
                          <li>使用 WebView 实现商品详情，并与JS交互实现相关商品跳转；</li>
                          <li>自定义封装商品属性类别，完成商品切换动画；</li>
                          <li>完全自定义实现侧边栏动态展开效果；</li>
                          <li>实现二维码扫描和条形码扫描，并进行了很好的封装。</li>
                        </ul>
                      </div>
                    </div>
                  </el-collapse-item>

                </el-collapse>

              </div>
            </div>

            <div>
              <div class="area" id="resume5">个人评价</div>
              <div class="info info-ul">
                <ul>
                  <li>工作上的经历造就了我严谨负责的工作态度，个性稳重，对任何事情都具有高度的责任感；</li>
                  <li>有良好的沟通能力、协调能力和团队合作能力；</li>
                  <li>热爱行业，勇于面对困难和挑战，具备吃苦耐劳精神和良好的职业素质；</li>
                  <li>富有责任心，学习能力强，工作认真负责高效；</li>
                  <li>性格开朗，对科技产品有浓厚的兴趣。</li>
                </ul>
              </div>
            </div>

          </div>
        </el-card>

      </el-main>
    </el-container>

  </div>

</template>

<script>
export default {
  name: 'ResumeInfo',
  data () {
    return {
      activeNames: ['1', '2', '3', '4'],
      treeData: [
        {
          id: '1',
          label: '基本信息'
        },
        {
          id: '2',
          label: '专业技能'
        },
        {
          id: '3',
          label: '工作经历'
        },
        {
          id: '4',
          label: '项目经验',
          children: [
            {
              id: '4-1',
              label: '开发项目（1）—— Starry'
            },
            {
              id: '4-2',
              label: '开发项目（2）—— 选剧'
            },
            {
              id: '4-3',
              label: '开发项目（3）—— 不眨眼'
            },
            {
              id: '4-4',
              label: '开发项目（4）—— 待购'
            }
          ]
        },
        {id: '5',
          label: '个人评价'
        }
      ],
      defaultProps: {
        children: 'children',
        label: 'label'
      }
    }
  },
  methods: {
    handleNodeClick (data) {
      // this.$el.querySelector('#resume' + data.id).scrollIntoView({
      //   behavior: 'smooth', // 平滑过渡
      //   block: 'start' // 上边框与视窗顶部平齐。默认值
      // })

      var anchor = this.$el.querySelector('#resume' + data.id)
      document.body.scrollTop = anchor.offsetTop - 100
      document.documentElement.scrollTop = anchor.offsetTop - 100
    }
  }
}
</script>

<style scoped>
.container{
  width: 1100px;
  margin: 0 auto;
}

.left-nvi{
  position: fixed;
  top: 150px;
}

.name-div{
  font-size: 40px;
  font-weight: bold;
}
.job-div{
  text-align: end;
  margin-top: 20px;
  font-size: 20px;
  line-height: 1.8;
  letter-spacing: 1px;
}

.area{
  font-size: 25px;
  height: 45px;
  color: #034172;
  text-align: center;
  margin-top: 30px;
  margin-bottom: 30px;
  border-bottom: 1.5px dashed #bfbfbf;
}

.project-title{
  font-size: 19px;
  font-weight: bold;
}

.title{
  font-weight: bold;
  font-size: 17px;
}

.info{
  font-size: 17px;
  line-height: 1.8;
  letter-spacing: 1px;
  margin: 5px 0;
}
.info-ul{
  margin-left: 23px;
}

.info-ol{
  margin-left: 40px;
}

</style>
<style>
.el-tree-node__label {
  font-size: 16px;
}

.el-tree-node__content {
  height: 30px;
}

.el-collapse-item__wrap{
  border-bottom: 0px solid #EBEEF5;
}
.el-collapse {
  border-top: 0px solid #EBEEF5;
  border-bottom: 0px solid #EBEEF5;
}
</style>



// WEBPACK FOOTER //
// src/components/pc/pages/resume/ResumeInfo.vue